<template>
  <div>
    <div>
      <transportation-volumes :ghgi="ghgi" />
    </div>
    <div>
      <transportation-emissions :ghgi="ghgi" />
    </div>
  </div>
</template>

<script>
export default {
  name: 'TransportationGraphs',
  props: {
    ghgi: {
      type: Object,
      default: null
    }
  },
  components: {
    'transportation-volumes': () => import('./TransportationVolumes.vue'),
    'transportation-emissions': () => import('./TransportationEmissions.vue')
  }
}
</script>
